import { string } from 'yup';

import { isFhirDateBefore } from './fhir';

/**
 * Validation for a FHIR date field that must not fall before an earlier date
 * elsewhere on the same form — a discharge date against an admission date, an
 * expiry date against an issue date, and so on. Equal dates are valid.
 *
 * Imprecise values are compared at their coarsest shared precision (see
 * `isFhirDateBefore`), so a year-only date from OCR extraction is not falsely
 * rejected against a full date in the same year. An empty or unrecognised value
 * on either side is left alone.
 *
 * @param referenceField Sibling field holding the date this one must not precede
 * @param message Error message to display when the dates are out of order
 * @returns Yup schema for the later of the two date fields
 */
export function dateNotBeforeSchema(referenceField: string, message: string) {
  return string().test(
    `not-before-${referenceField}`,
    message,
    (value, ctx) =>
      !isFhirDateBefore(
        value,
        (ctx.parent as Record<string, string | null | undefined>)[
          referenceField
        ]
      )
  );
}

export const isValidEmail = (email: string) => {
  const schema = string().email().required();
  try {
    const result = schema.validateSync(email);
    return Boolean(result);
  } catch {
    return false;
  }
};
